<template>
    <div class="flex flex-col mb-4 bg-white shadow-xl rounded-2xl border-box">
        <div class="relative flex rounded-t-lg">
            <div class="absolute z-40 py-1 pl-2 pr-3 text-sm font-semibold text-white bg-gradient-to-r from-pink-600">{{ bookDetails.product_category.name }}</div>
            <img
                :src="bookDetails.cover_image"
                class="box-border rounded-t-lg"
            />
        </div>
        <section
            class="flex flex-col w-full p-4 border-0 border-solid rounded-2xl border-box md:text-xl"
        >
            <header class="box-border pb-1 text-lg font-bold text-pink-700">
                {{ bookDetails.title }}
            </header>
            <main class="flex flex-col justify-between text-base text-black grow md:text-sm md:gap-4">
                <div class="text-justify grow cust-min-height">
                    {{ bookDetails.description ? bookDetails.description.substr(0, 400) : ""}}
                    {{ bookDetails.description.substr(401) ? "...." : "" }}
                </div>
                <div class="pb-6 bg-white rounded-b-lg w-fiull">
                    <div class="flex items-start justify-start">
                        <span v-if="bookDetails.category_id == 1" class="px-4 py-1 italic font-semibold text-pink-600 border-2 border-pink-600 border-solid rounded-xl hover:bg-pink-600 hover:text-white">
                           <a :href="route('audiobook.show', bookDetails.book_data.id)">
                                {{ $t('ascolta') }}
                            </a> 
                        </span>
                        <span v-if="bookDetails.category_id == 2" class="px-4 py-1 italic font-semibold text-pink-600 border-2 border-pink-600 border-solid rounded-xl hover:bg-pink-600 hover:text-white">
                            <a :href="`/img/ebooks/pdf/${bookDetails.book_data.pdf_url}`" target="_blank">
                                {{ $t('download') }}
                            </a>
                        </span>
                        <span v-if="bookDetails.category_id == 3" class="px-4 py-1 italic font-semibold text-pink-600 border-2 border-pink-600 border-solid rounded-xl hover:bg-pink-600 hover:text-white">
                            {{ $t('ascolta') }}
                        </span>
                        <span v-if="bookDetails.category_id == 4" class="px-4 py-1 italic font-semibold text-pink-600 border-2 border-pink-600 border-solid rounded-xl hover:bg-pink-600 hover:text-white">
                            {{ $t('ascolta') }}
                        </span>
                        <!-- <img src="/img/icons/arrow_to_right.svg" class="h-4 border-2 border-pink-600 border-solid rounded-full aspect-square"> -->
                    </div>
                </div>
            </main>
        </section>
    </div>
</template>

<script>
    export default {
        props: {
            bookDetails: {
                type: Object,
                required: true,
            },
        },
        emits: ["cardClicked"],
    };
</script>
<style scoped>
    .cust-min-height {
        min-height: 12.8rem;
    }
</style>